import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "tips-and-tricks-for-uxp-scripts"
    }}>{`Tips and tricks for UXP scripts`}</h1>
    <p>{`Additional tips and tricks that will help you while developing UXP Scripts.`}</p>
    <h2 {...{
      "id": "scripts-panel"
    }}>{`Scripts panel`}</h2>
    <p>{`The InDesign Scripts panel is the easiest and best way to run most InDesign scripts. If the panel is not already visible, you can display it by choosing Window > Utilities > Scripts.`}</p>
    <h3 {...{
      "id": "editing-scripts"
    }}>{`Editing scripts`}</h3>
    <p>{`To edit a script shown in the Scripts panel, select the script and choose Edit Script from the Scripts panel menu. Alternatively, you can hold down the Option (macOS) or Alt (Windows) key and double-click the script's name. This opens the script in the editor you defined for the script file type.`}</p>
    <h3 {...{
      "id": "open-folder"
    }}>{`Open folder`}</h3>
    <p>{`To open the folder containing a script shown in the Scripts panel, select the script and choose Reveal in Finder (macOS) or Reveal in Explorer (Windows). Alternatively, you can hold down the Command (macOS) or Ctrl-Shift (Windows) keys and double-click the script's name. The script folder opens in the Finder (macOS) or Explorer (Windows).`}</p>
    <h3 {...{
      "id": "keyboard-shortcuts"
    }}>{`Keyboard shortcuts`}</h3>
    <p>{`To add a keyboard shortcut for a script, choose Edit > Keyboard Shortcuts, select `}<inlineCode parentName="p">{`[Default]`}</inlineCode>{` from the Set menu, then choose Product Area > Scripts. A list of the scripts in your Scripts panel appears. Select a script and assign a keyboard shortcut as you would for any other InDesign feature.`}</p>
    <h2 {...{
      "id": "run-script-during-application-startup"
    }}>{`Run script during application startup`}</h2>
    <p>{`To run a specific script when InDesign starts, put it inside a folder named "Startup Scripts" inside the Scripts folder`}</p>
    <ul>
      <li parentName="ul">{`macOS - `}<inlineCode parentName="li">{`/Applications/Adobe InDesign 2023/Scripts/startup scripts`}</inlineCode></li>
      <li parentName="ul">{`Windows - `}<inlineCode parentName="li">{`%APPDATA%\\Adobe\\InDesign\\Version 19.0\\en_US\\Scripts\\startup scripts`}</inlineCode></li>
    </ul>
    <p>{`Adjust the version number of InDesign in the above path based on your local environment. And create the folders if it does not already exist.`}</p>
    <h2 {...{
      "id": "associate-a-text-editor-for-idjs-files"
    }}>{`Associate a Text-Editor for .idjs Files`}</h2>
    <p>{`Associate idjs files to your preferred editor by following these steps:`}</p>
    <h3 {...{
      "id": "on-mac"
    }}>{`On Mac`}</h3>
    <ol>
      <li parentName="ol">{`Right-click any `}<inlineCode parentName="li">{`.idjs`}</inlineCode>{` file`}</li>
      <li parentName="ol">{`Click "Get Info"`}</li>
      <li parentName="ol">{`Under "Open With",  select an editor of your choice from the application list `}</li>
      <li parentName="ol">{`If not visible in the list, click "Other", and select an editor from the "Applications" folder, and click "Add"`}</li>
      <li parentName="ol">{`Click the button that says "Change All" and then "Continue".`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "207px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "144.9275362318841%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/716a92c99a9c5a1d79feea934118ab4a/ee7f6/1.webp 207w"],
            "sizes": "(max-width: 207px) 100vw, 207px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/716a92c99a9c5a1d79feea934118ab4a/3c09e/1.png 207w"],
            "sizes": "(max-width: 207px) 100vw, 207px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/indesign/uxp/static/716a92c99a9c5a1d79feea934118ab4a/3c09e/1.png",
            "alt": "Mac Text-Editor Association for .idjs Files",
            "title": "Mac Text-Editor Association for .idjs Files",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "50%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/e950f4c1755846729d3b3c2301b55d12/5530d/2.webp 320w", "/indesign/uxp/static/e950f4c1755846729d3b3c2301b55d12/0c8fb/2.webp 640w", "/indesign/uxp/static/e950f4c1755846729d3b3c2301b55d12/94b1e/2.webp 1280w", "/indesign/uxp/static/e950f4c1755846729d3b3c2301b55d12/0f190/2.webp 1800w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/e950f4c1755846729d3b3c2301b55d12/dd4a7/2.png 320w", "/indesign/uxp/static/e950f4c1755846729d3b3c2301b55d12/0f09e/2.png 640w", "/indesign/uxp/static/e950f4c1755846729d3b3c2301b55d12/bbbf7/2.png 1280w", "/indesign/uxp/static/e950f4c1755846729d3b3c2301b55d12/28bdc/2.png 1800w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/indesign/uxp/static/e950f4c1755846729d3b3c2301b55d12/bbbf7/2.png",
            "alt": "Mac Text-Editor Association for .idjs Files",
            "title": "Mac Text-Editor Association for .idjs Files",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1104px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "55.3125%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/530c0d9974b8b6d88455debf8ad491cb/5530d/3.webp 320w", "/indesign/uxp/static/530c0d9974b8b6d88455debf8ad491cb/0c8fb/3.webp 640w", "/indesign/uxp/static/530c0d9974b8b6d88455debf8ad491cb/8d95b/3.webp 1104w"],
            "sizes": "(max-width: 1104px) 100vw, 1104px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/530c0d9974b8b6d88455debf8ad491cb/dd4a7/3.png 320w", "/indesign/uxp/static/530c0d9974b8b6d88455debf8ad491cb/0f09e/3.png 640w", "/indesign/uxp/static/530c0d9974b8b6d88455debf8ad491cb/829bf/3.png 1104w"],
            "sizes": "(max-width: 1104px) 100vw, 1104px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/indesign/uxp/static/530c0d9974b8b6d88455debf8ad491cb/829bf/3.png",
            "alt": "Mac Text-Editor Association for .idjs Files",
            "title": "Mac Text-Editor Association for .idjs Files",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "on-windows"
    }}>{`On Windows:`}</h3>
    <ol>
      <li parentName="ol">{`Right-click any `}<inlineCode parentName="li">{`.idjs`}</inlineCode>{` file`}</li>
      <li parentName="ol">{`Click "Open with"`}</li>
      <li parentName="ol">{`Select an editor of your choice from the application list `}</li>
      <li parentName="ol">{`If not visible in the list, click "Choose another app", and if needed, "More apps" → "Look for another app on this PC" `}</li>
      <li parentName="ol">{`Navigate to the directory containing the editor and select it`}</li>
      <li parentName="ol">{`Enable "Always use this app to open .idjs files".`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1168px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "62.81249999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/c69323bb5fceb705aca92b797939fb51/5530d/4.webp 320w", "/indesign/uxp/static/c69323bb5fceb705aca92b797939fb51/0c8fb/4.webp 640w", "/indesign/uxp/static/c69323bb5fceb705aca92b797939fb51/ba85f/4.webp 1168w"],
            "sizes": "(max-width: 1168px) 100vw, 1168px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/c69323bb5fceb705aca92b797939fb51/dd4a7/4.png 320w", "/indesign/uxp/static/c69323bb5fceb705aca92b797939fb51/0f09e/4.png 640w", "/indesign/uxp/static/c69323bb5fceb705aca92b797939fb51/b38ab/4.png 1168w"],
            "sizes": "(max-width: 1168px) 100vw, 1168px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/indesign/uxp/static/c69323bb5fceb705aca92b797939fb51/b38ab/4.png",
            "alt": "Windows Text-Editor Association for .idjs Files",
            "title": "Windows Text-Editor Association for .idjs Files",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "197px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "145.68527918781726%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/5c2a260b73fb49aa768e7091b6f4fbc9/41ef6/5.webp 197w"],
            "sizes": "(max-width: 197px) 100vw, 197px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/5c2a260b73fb49aa768e7091b6f4fbc9/fab3c/5.png 197w"],
            "sizes": "(max-width: 197px) 100vw, 197px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/indesign/uxp/static/5c2a260b73fb49aa768e7091b6f4fbc9/fab3c/5.png",
            "alt": "Windows Text-Editor Association for .idjs Files",
            "title": "Windows Text-Editor Association for .idjs Files",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      